export const DEMO_REP = "Arjun Mehta"

export const DEMO_LISTS = [
  {
    id: "priority-champions",
    name: "Priority champions",
    kind: "priority",
    people: [
      {
        id: 1001,
        name: "Sayan",
        title: "Tester contact",
        phone: "+917283930645",
        linkedin_url: "https://www.linkedin.com/in/sayan-patel/",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1004,
        name: "Chandra",
        title: "Tester contact",
        phone: "+916303990729",
        linkedin_url: "https://www.linkedin.com/in/chandra-penugonda/",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1007,
        name: "Madhu",
        title: "Tester contact",
        phone: "+917893711555",
        linkedin_url: "https://www.linkedin.com/in/madhumanne/",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1008,
        name: "Giri",
        title: "Tester contact",
        phone: "+919022346716",
        linkedin_url: "https://www.linkedin.com/in/giri-dhar-21a8b1b7/",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1009,
        name: "Arpita",
        title: "Tester contact",
        phone: "+919538740410",
        linkedin_url: "https://www.linkedin.com/in/arpita-kembhavi-a077b91b7/",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1010,
        name: "Baudhik Malik",
        title: "Tester contact · Executor",
        phone: "+919413938475",
        linkedin_url: "https://www.linkedin.com/in/baudhikmalik/",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1011,
        name: "Shalini",
        title: "Tester contact",
        phone: "+919513877404",
        linkedin_url: "https://www.linkedin.com/in/shalini-singh-9792b220b/",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      },
      {
        id: 1012,
        name: "Yashi",
        title: "Tester contact · US line",
        phone: "+12012790892",
        location_country: "IN",
        account: { id: "creative-planning", name: "Creative Planning" }
      }
    ]
  }
]
